var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFriendTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "B_\\u5DE5\\u4F5C\\u53F0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    transform: "translate(-470.000000, -115.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u52A0\\u597D\\u53CB\\u4EFB\\u52A1",
    transform: "translate(451.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-",
    transform: "translate(5.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2424242,30.4848485 C42.5269503,30.4848485 46,33.9578982 46,38.2424242 C46,42.5269503 42.5269503,46 38.2424242,46 C33.9578982,46 30.4848485,42.5269503 30.4848485,38.2424242 C30.4848485,33.9578982 33.9578982,30.4848485 38.2424242,30.4848485 Z M28.5454545,38.2424242 C28.5454545,40.8855425 29.6029364,43.2816726 31.3178935,45.030808 L18.3335423,45.0300796 C16.0388485,45.0300796 14.1418446,43.2005188 14.0072226,40.8572727 L14,40.5972111 L14,37.6419654 C14,33.6864908 17.0459091,30.4329069 20.909111,30.2612393 L21.2225705,30.2538512 L32.7442708,30.2537497 C30.2078731,32.0027363 28.5454545,34.9284409 28.5454545,38.2424242 Z M38.2424242,33.3939394 C37.5100859,33.3939394 37.2727273,34.00931 37.2727273,34.3652182 L37.2727273,34.3652182 L37.2727273,37.2727273 L34.3636364,37.2727273 C34.013862,37.2727273 33.3939394,37.6136314 33.3939394,38.2424242 C33.3939394,38.8712171 34.013862,39.2121212 34.3636364,39.2121212 L34.3636364,39.2121212 L37.2727273,39.2121212 L37.2727273,42.1212121 C37.2727273,42.4771203 37.497927,43.0909091 38.2424242,43.0909091 C38.9869214,43.0909091 39.2121212,42.4771203 39.2121212,42.1212121 L39.2121212,42.1212121 L39.2121212,39.2121212 L42.1212121,39.2121212 C42.4694319,39.2121212 43.0909091,38.9788926 43.0909091,38.2424242 C43.0909091,37.5059559 42.4709864,37.2727273 42.1212121,37.2727273 L42.1212121,37.2727273 L39.2121212,37.2727273 L39.2121212,37.2727273 L39.2121212,34.3636364 C39.2121212,34.0077282 38.9747626,33.3939394 38.2424242,33.3939394 Z M28.4451411,14 C32.4340566,14 35.6677116,17.3077714 35.6677116,21.3881142 C35.6677116,25.468457 32.4340566,28.7762284 28.4451411,28.7762284 C24.4562255,28.7762284 21.2225705,25.468457 21.2225705,21.3881142 C21.2225705,17.3077714 24.4562255,14 28.4451411,14 Z",
    id: "add"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFriendTasks);
export default __webpack_public_path__ + "static/media/add-friend-tasks.be21e294.svg";
export { ForwardRef as ReactComponent };